module.exports = __webpack_public_path__ + "img/03_special_cycles_(white).5381e7dd.svg";